<div class="h-dvh flex flex-col">
    <app-banner></app-banner>
    <app-header></app-header>
    @if (this.showActionRequired()) {
        @defer (on idle) {
            <app-action-required
                class="absolute z-50 right-0 top-[calc(50%-80px)] rotate-[-90deg] origin-bottom-right"
            ></app-action-required>
        }
    }
    <main
        class="flex-1 overflow-x-hidden overflow-y-auto"
        [class]="
            isMenu()
                ? isNewDesign()
                    ? 'bg-[url(/assets/images/new_menu_background.png)]'
                    : 'no-scrollbar bg-[url(/assets/images/menu_background.png)]'
                : ''
        "
        [ngClass]="{
            'w-full bg-no-repeat bg-center bg-cover bg-fixed': isMenu,
            'bg-[#141414]': isNewDesign,
            'pt-[120px]': !showEnvironmentHint(),
            'pt-[150px]': showEnvironmentHint(),
            'md:pt-[70px]': !showEnvironmentHint(),
            'md:pt-[100px]': showEnvironmentHint()
        }"
    >
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>
